'use client';
import BazaarvoiceRating from '@repo/ui/src/components/BazaarvoiceRating';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

export interface ProductHeadingProps {
  product: MeaterProduct;
  className?: string;
  dark?: boolean;
  titleVariant?: string;
  banner?: React.ReactNode;
  showReviews?: boolean;
}

const ProductHeading = ({
  product,
  className,
  dark,
  titleVariant = 'tra-text-web-heading-2',
  banner,
  showReviews = true,
}: ProductHeadingProps) => {
  const ratingId = product.bvProductId ?? product.shopifyId;

  return (
    <div
      className={classNames(
        'md:pr-[5vw] md:pl-0',
        dark && 'md:bg-transparent text-white',
        className,
      )}
    >
      {banner && <div className="flex justify-start mb-2 md:mb-5">{banner}</div>}
      {product.smallHeading && (
        <p className="tra-text-web-sub-2 uppercase text-left">{product.smallHeading}</p>
      )}
      <h1 className={classNames('text-left', titleVariant)}>
        {product.shortTitleMain ? (
          <>
            {product.shortTitleMain} <span>{product.shortTitlePrimary}</span>
          </>
        ) : (
          product.title
        )}
      </h1>
      <div className={classNames('flex gap-4 py-2 md:pt-4 md:pb-0 items-center justify-start')}>
        {showReviews && (
          <a href="#reviews">
            <BazaarvoiceRating id={ratingId} enableSEO={false} type="summary" />
          </a>
        )}
      </div>
    </div>
  );
};

export default ProductHeading;
